// import stripe from 'stripe';
// const stripe = require('@stripe/stripe-js')('sk_test_ko1Hp1CX04FKgXaIS0apbeGj00shEk58oU');
import { Elements } from '@stripe/react-stripe-js';
import ClassCheckout from 'components/ClassCheckout';
import ClassConfirmation from 'components/ClassConfirmation';
import ClassList from 'components/ClassList';
import { useDispatch } from 'react-redux';
import React from "react";
import { useLocation } from "react-router-dom";
// import AsyncStripeProvider from 'util/AsyncStripeProvider';
import { StripeProvider } from 'react-stripe-elements';
import { Route, Switch, useRouter } from "util/router.js";
import {useWidget} from 'util/widget'
import { fetchInstructorData } from 'store/actions/widgetActions';
import "./classWidget.scss";

// / A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ClassWidget(props) {
    const widget = useWidget()
    const dispatch = useDispatch();
    React.useEffect(() => {
        // console.log("useWidget: ", widget)
        if (widget && widget.widgetName) {
            dispatch(fetchInstructorData(widget.widgetName, "classes"));
        }
    }, [dispatch, widget.widgetName])
    const { match, stripe, challengeid } = props;
    return (
    <>
        <Switch>
            <Route 
                path={`${match.url}/confirm/:platformID`}
                render={props => {
                    return  (<>
                        <ClassConfirmation {...props} />
                    </>)
                    
                }} 
            />
            <Route
                path={`${match.url}/checkout/:platformID`} 
                render={props => {
                    
                    return (<>
                    <StripeProvider stripe={stripe} >
                        <Elements stripe={stripe} >
                            <ClassCheckout {...props} />
                        </Elements>
                    </StripeProvider>
                    </>)
                }}
            />
            <Route
                path={`${match.url}`}
                render={props => {
                    return (<>
                        <ClassList challengeid={challengeid} {...props}/>
                    </>)
                }}>
                
            </Route>
        </Switch>
    </>
    )
}

export default ClassWidget;